export default import.meta.ROLLDOWN_FILE_URL_14x__yS6Z4Ee$7STDgNF2Q